import PdfGenerator from "../../components/pdfViewer/PdfGenerator";
import DonationReciptPdf from "../../pdfs/DonationReciptPdf";
import { useLocation } from "react-router-dom";

const Pdf = () => {
  const location = useLocation();

  const locationData = {
    data: location?.state?.data || {},
    type: location?.state?.type,
    fileName: location?.state?.data?.invoiceId || "download.pdf",
  };

  return (
    <PdfGenerator fileName={locationData?.fileName} data={locationData?.data}>
      {locationData?.type === "DonationReciptPdf" && <DonationReciptPdf />}
    </PdfGenerator>
  );
};

export default Pdf;
